import React from "react";
import PropTypes from "prop-types";
import { Map } from "immutable";
import {
  CAN_RELEASE_QC_HOLD,
  CREATE_VENDOR_RMAS,
  ROLES,
  SUBROLES,
  WAREHOUSE,
  WAREHOUSE_BASIC
} from "MODULES/users/constants";
import { without } from "lodash";
import Authorized from "MODULES/shared/components/Authorized";
import ActionDropDown from "MODULES/shared/components/ActionDropDown/ActionDropDown";
import DropDownAction, { Config } from "./DropdownActions";

const renderRows = (inventory, config) =>
  Object.keys(config).map(key => (
    <DropDownAction inventory={inventory} config={config[key]} key={key} />
  ));

export default function InventoryDropdown({ inventory }) {
  return (
    <Authorized
      roles={without(ROLES, WAREHOUSE)}
      subroles={without(SUBROLES, WAREHOUSE_BASIC)}
      permissions={[CAN_RELEASE_QC_HOLD, CREATE_VENDOR_RMAS]}
    >
      <ActionDropDown
        menuClass="dropdown-menu-right"
        style={{ cursor: "pointer" }}
      >
        {renderRows(inventory, Config)}
      </ActionDropDown>
    </Authorized>
  );
}

InventoryDropdown.propTypes = {
  inventory: PropTypes.instanceOf(Map)
};



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/Header/InventoryDropdown.jsx